import { useEffect, useState } from 'react';
import { fetchAdminKpi, AdminKpiError, type AdminKpi, type AdminWindow } from '../services/adminKpi';

/**
 * Charge les KPI du dashboard admin pour la fenêtre choisie, et les recharge à chaque changement
 * de fenêtre. `forbidden` distingue le refus de rôle (sécurité serveur) d'une erreur technique.
 */
export function useAdminKpi(initialWindow: AdminWindow = 'current') {
  const [window, setWindow] = useState<AdminWindow>(initialWindow);
  const [kpi, setKpi] = useState<AdminKpi | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [forbidden, setForbidden] = useState(false);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);
    setForbidden(false);
    fetchAdminKpi(window)
      .then((k) => {
        if (active) setKpi(k);
      })
      .catch((e) => {
        if (!active) return;
        if (e instanceof AdminKpiError && e.forbidden) setForbidden(true);
        setError(e instanceof Error ? e.message : 'Chargement impossible.');
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [window]);

  return { window, setWindow, kpi, loading, error, forbidden };
}
